import { render, staticRenderFns } from "./EmailNew.vue?vue&type=template&id=7841a578"
import script from "./EmailNew.vue?vue&type=script&lang=js"
export * from "./EmailNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports